import { IUpdateUserRequest } from '../api/types/sessions'
import {
  inviteUser as inviteUserApi,
  verifyInvite as verifyInviteApi,
  deleteUser as deleteUserApi,
  updateUser as updateUserApi,
  deleteInvite as deleteInviteApi
} from '../api/user'
import { setUser } from '../state/slices/user_slice'
import { logout } from '../state/actions/constants'
import { useAppDispatch } from './state'

export const useUser = () => {
  const dispatch = useAppDispatch()

  const inviteUser = async (
    relationNumber: number,
    email: string
  ) => await inviteUserApi(relationNumber, email)

  const verifyInvite = async (
    email: string,
    type: string,
    relationNumber: number,
    password: string,
    passwordConfirmation: string
  ) => await verifyInviteApi(email, type, relationNumber, password, passwordConfirmation)

  const deleteUser = async () => {
    const result = await deleteUserApi()

    dispatch(logout())

    return result
  }

  const deleteInvite = async (relationNumber: number, token: string) => await deleteInviteApi(relationNumber, token)

  const updateUser = async (request: IUpdateUserRequest) => {
    const result = await updateUserApi(request)

    if (result.data?.user) {
      dispatch(setUser(result.data.user))
    }

    return result
  }

  return {
    inviteUser,
    verifyInvite,
    deleteUser,
    updateUser,
    deleteInvite
  }
}

export default useUser
